// B4-D: mirrors com.kervolt.oms.sales.salesreturn.SalesReturnDtos.
export type SalesReturnStatus = 'DRAFT' | 'POSTED' | 'CANCELLED';
export type ReturnCondition = 'RESALEABLE' | 'DAMAGED';

export const RETURN_STATUS_COLORS: Record<SalesReturnStatus, 'default' | 'success' | 'error'> = {
  DRAFT: 'default', POSTED: 'success', CANCELLED: 'error',
};

export interface ReturnLineRequest { deliveryChallanLineId: string; quantity: number; condition: ReturnCondition; }
export interface ReturnRequest {
  deliveryChallanId: string; storeId?: string; returnDate: string; reason: string; lines: ReturnLineRequest[];
}

export interface ReturnLine {
  id: string; deliveryChallanLineId: string; salesOrderLineId?: string; itemId?: string; itemCode?: string; itemName?: string;
  description?: string; quantity: number; condition: ReturnCondition; unitCost?: number; lineValue?: number; unitPrice?: number;
  /** F6c: a kit line's per-component restock (resaleable) or write-off (damaged); empty otherwise. */
  kitComponents?: ReturnKitComponent[];
}
export interface ReturnKitComponent {
  componentItemId: string; code?: string | null; name?: string | null; unit?: string | null; quantity: number; value: number;
}
export interface CreditNoteLink { id: string; creditNoteNumber: string; status: string; totalAmount: number; }

export interface SalesReturn {
  id: string; institutionId: string; returnNo?: string; customerId: string; customerName?: string; salesOrderId: string;
  orderNo?: string; deliveryChallanId: string; challanNo?: string; storeId: string; storeName?: string; returnDate: string;
  reason: string; status: SalesReturnStatus; restockValue: number; damagedValue: number; deliveredAdjusted: boolean;
  invoiceId?: string; invoiceNumber?: string; journalEntryId?: string; reversalJournalEntryId?: string; postedAt?: string;
  cancelReason?: string; canCreateCreditNote: boolean; lines: ReturnLine[]; creditNotes: CreditNoteLink[];
  salespersonId?: string | null; salespersonName?: string | null; salesTeamId?: string | null;   // S0
}

export interface SalesReturnSummary {
  id: string; returnNo?: string; customerId: string; customerName?: string; deliveryChallanId: string; challanNo?: string;
  orderNo?: string; returnDate: string; status: SalesReturnStatus; restockValue: number; damagedValue: number;
  salespersonId?: string | null; salespersonName?: string | null;   // S0
}

export interface ReturnableLine {
  deliveryChallanLineId: string; salesOrderLineId?: string; itemId?: string; itemCode?: string; itemName?: string;
  description?: string; delivered: number; returned: number; available: number; unitPrice?: number;
}
export interface Returnable {
  deliveryChallanId: string; challanNo?: string; salesOrderId: string; orderNo?: string; customerId: string;
  customerName?: string; storeId: string; invoiceId?: string; invoiceNumber?: string; invoiceIssued: boolean;
  lines: ReturnableLine[];
}

export interface CreditNoteDraftLine {
  salesInvoiceLineId: string; description?: string; quantity: number; unitPrice?: number; taxCodeId?: string; taxRatePct?: number;
}
export interface CreditNoteDraft {
  salesReturnId: string; salesInvoiceId: string; invoiceNumber?: string; noteDate: string; reason: string;
  lines: CreditNoteDraftLine[];
}

export interface ReturnSettings { institutionId: string; damagedGoodsAccountId?: string | null; }
